import { useEffect, useState } from "react";
import { Button, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toggleActivation } from "../../../store/actions/wardsAction";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
import Popup from "../../common/modal/Popup";
const ToggelActivatateWardPopup = ({
  toggleActivateRec,
  toggleActivateStatus,
  onHide,
  toggleActivateModalShow,
  setToggleActivateModalShow,
}) => {
  const [isAction, setIsAction] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const [warning, setWarning] = useState(false);
  const dispatch = useDispatch();
  const {
    isRecordAdded,
    isRecordUpdated,
    error: apiError,
  } = useSelector((state) => state.clients);

  const submitHandler = (e) => {
    setIsAction(true);
    return dispatch(
      toggleActivation({
        wardId: toggleActivateRec?._id,
      })
    ).then(() => {
      setIsDone(true);
      onHide();
      setToggleActivateModalShow(false);
    });
  };

  const hideHandlerRes = () => {
    setIsAction(false);
    setIsDone(false);
  };
  useEffect(() => {
    console.log("toggleActivateRec", toggleActivateRec);
    let occupiedText = "";
    let reservedText = "";
    if (toggleActivateRec?.occupiedBeds) {
      occupiedText =
        "This ward have " + toggleActivateRec?.occupiedBeds + " occupied bed";
    }
    if (toggleActivateRec?.reservedBeds) {
      if (occupiedText != "") {
        reservedText =
          " and " + toggleActivateRec?.reservedBeds + " reserved bed. ";
      } else {
        reservedText =
          ";. Ward have " + toggleActivateRec?.reservedBeds + " reserved bed. ";
      }
    }
    if (occupiedText != "" || reservedText != "") {
      setWarning(
        occupiedText +
          reservedText +
          " After deactivating the ward these beds will get released. Are you sure you want to deactivate this ward?"
      );
    } else {
      setWarning("Are you sure you want to deactivate this ward?");
    }
  }, [toggleActivateRec]);

  return (
    <>
      <Popup
        onHide={() => onHide()}
        size="md"
        show={toggleActivateModalShow}
        title={toggleActivateStatus ? "Deactivate Ward" : "Activate Ward"}
        footer={
          <>
            <Button
              variant="outline-secondary model-btn"
              className="me-4"
              onClick={(e) => onHide()}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary model-btn"
              onClick={(e) => submitHandler()}
            >
              Confirm
            </Button>
          </>
        }
      >
        {apiError && (
          <Alert variant={"danger"}>
            {apiError?.message || "Access denied! Please try again"}
          </Alert>
        )}
        <div style={{ textAlign: "center" }}>
          {toggleActivateStatus
            ? warning
            : "Are you sure you want to activate this ward?"}
        </div>
      </Popup>
      {isAction && (
        <ApiResponsePopup
          {...{
            hideHandlerRes,
            isRecordUpdated: isDone,
            title: toggleActivateStatus ? "Deactivate Ward" : "Activate Ward",
            successMsg: toggleActivateStatus
              ? "Ward deactivated successfully!"
              : "Ward activated successfully!",
          }}
        />
      )}
    </>
  );
};

export default ToggelActivatateWardPopup;
